import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { ColorConfigurationSelect } from '../inputs/ColorConfigurationSelect';
import { optionFilterBySystem } from '../inputs/ConfigurationSelect';
import { PaintColorValue } from '../readonly/PaintColorValue';
import { ConfigurationComponent } from '.';

const PaintColorOutsideConfig = () => (
  <ColorConfigurationSelect
    configurationKey="paintColorOutside"
    dispatchAction="SET_PAINT_COLOR_OUTSIDE"
    optionsFilterFn={optionFilterBySystem}
  />
);

const config: ConfigurationComponent<'paintColorOutside'> = {
  key: 'paintColorOutside',
  input: <PaintColorOutsideConfig />,
  display: (value: ConfigurationValues['paintColorOutside']) => (
    <PaintColorValue value={value} />
  ),
};

export default config;
